import React from 'react';
import {
    Badge,
    Box,
    SimpleGrid,
    Stat,
    StatHelpText,
    StatLabel,
    StatNumber,
    Text,
    VStack,
    Wrap,
    WrapItem,
} from '@chakra-ui/react';

function DashboardRoleBrief({
    title,
    description,
    highlights = [],
    focusAreas = [],
    lastUpdatedLabel,
    bg = 'white',
    borderColor = 'gray.200',
    titleColor = 'gray.800',
    descriptionColor = 'gray.600',
    accentColor = 'brand.navy',
    cardBg = 'gray.50',
}) {
    return (
        <Box
            bg={bg}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="xl"
            boxShadow="sm"
            px={{ base: 4, md: 6 }}
            py={{ base: 4, md: 5 }}
        >
            <VStack align="stretch" spacing={4}>
                <Box>
                    <Badge colorScheme="blue" borderRadius="full" px={3} py={1} mb={3}>
                        Role focus
                    </Badge>
                    <Text as="h2" fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold" color={titleColor}>
                        {title}
                    </Text>
                    {description ? (
                        <Text mt={2} color={descriptionColor} fontSize="sm">
                            {description}
                        </Text>
                    ) : null}
                    {lastUpdatedLabel ? (
                        <Text mt={2} color={descriptionColor} fontSize="xs">
                            Last refreshed: {lastUpdatedLabel}
                        </Text>
                    ) : null}
                </Box>

                {highlights.length > 0 ? (
                    <SimpleGrid columns={{ base: 1, md: Math.min(highlights.length, 3) }} spacing={3}>
                        {highlights.map((item) => (
                            <Stat
                                key={item.label}
                                bg={cardBg}
                                borderWidth="1px"
                                borderColor={borderColor}
                                borderRadius="lg"
                                px={4}
                                py={4}
                            >
                                <StatLabel color={descriptionColor}>{item.label}</StatLabel>
                                <StatNumber color={accentColor} fontSize={{ base: 'lg', md: 'xl' }}>
                                    {item.value}
                                </StatNumber>
                                {item.help ? (
                                    <StatHelpText color={descriptionColor} mb={0}>
                                        {item.help}
                                    </StatHelpText>
                                ) : null}
                            </Stat>
                        ))}
                    </SimpleGrid>
                ) : null}

                {focusAreas.length > 0 ? (
                    <Wrap spacing={2}>
                        {focusAreas.map((item) => (
                            <WrapItem key={item}>
                                <Badge
                                    borderRadius="full"
                                    px={3}
                                    py={1.5}
                                    bg={cardBg}
                                    color={titleColor}
                                    borderWidth="1px"
                                    borderColor={borderColor}
                                    textTransform="none"
                                    fontSize="0.78rem"
                                    whiteSpace="normal"
                                >
                                    {item}
                                </Badge>
                            </WrapItem>
                        ))}
                    </Wrap>
                ) : null}
            </VStack>
        </Box>
    );
}

export default DashboardRoleBrief;
